// ************
// Recipe Single View
// Download PDF Button
// and
// Favorite Button
// ************
import { useAppContext } from "@/context/AppContext";
import { RecipeType } from "@/types/baseTypes";
import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";
import { ReactSVG } from "react-svg";
import { onClickPdfDownload } from "../../PDFDownloadButton/PDFDownloadButton";
import { LoaderCircle } from "@/components/Global/LoaderCircle/LoaderCircle";
import { useRecipeLikes } from "@/hooks/useRecipeLikes";

interface RecipeDownloadProps {
  recipeDetails: RecipeType;
  favCount: number;
}

function RecipeDownload({ recipeDetails, favCount }: RecipeDownloadProps) {
  const { totalLikes, userLikedRecipe, handleLike } = useRecipeLikes(
    recipeDetails.rezept_id,
    true,
    favCount,
  );
  const { getIcon, getLabel } = useGlobalContext();
  const { loading, setLoading } = useAppContext();

  const InteractiveButton = ({
    src,
    subline,
    onClick,
    ariaLabel,
    className,
  }: {
    src: string;
    subline: string;
    onClick?: () => void;
    ariaLabel?: string;
    className?: string;
  }) => {
    return (
      <button
        className={`button-reset ${className || ""}`}
        onClick={onClick}
        aria-label={ariaLabel}
      >
        <ReactSVG
          src={src}
          width={24}
          height={24}
          wrapper="svg"
          beforeInjection={(svg) => {
            svg.setAttribute("width", "24");
            svg.setAttribute("height", "24");
            svg.setAttribute("aria-hidden", "true");
          }}
          aria-hidden
        />
        <p>{subline}</p>
      </button>
    );
  };

  return (
    <>
      <InteractiveButton
        src={getIcon("pdfDownload")}
        subline={"PDF"}
        className="mr-5"
        onClick={() =>
          onClickPdfDownload({
            getIcon,
            getLabel,
            printList: [{ item: recipeDetails, index: 0 }],
            pdfType: "recipe",
            setLoading,
          })
        }
      />
      <InteractiveButton
        src={userLikedRecipe ? getIcon("heartFilled") : getIcon("heartEmpty")}
        subline={totalLikes.toString() || "0"}
        onClick={handleLike}
        ariaLabel={
          userLikedRecipe
            ? getLabel("aria_label_recipe_remove_favorite").replace(
                "$$title",
                recipeDetails.rezept_titel,
              )
            : getLabel("aria_label_recipe_add_favorite").replace(
                "$$title",
                recipeDetails.rezept_titel,
              )
        }
      />
      {loading && <LoaderCircle position="relative" />}
    </>
  );
}

export default RecipeDownload;
